<template>
  <div class="category-panel">
    <div class="category-panel__header">
      <div class="category-panel__title">
        <h4>Categories</h4>
        <button @click="clearCategory" class="category-panel__reset-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </button>
      </div>

      <div class="category-panel__breadcrumbs">
        <nav aria-label="breadcrumb">
          <ol>
            <li v-if="categorySearch.category">
              <a @click.prevent="selectMainCategory" href="#">
                {{ categorySearch.category }}
              </a>
            </li>
            <li v-if="categorySearch.subCategory">
              <a @click.prevent="selectSubCategory" href="#">
                {{ categorySearch.subCategory }}
              </a>
            </li>
            <li v-if="categorySearch.sub2Category" class="active">
              <a href="#">
                {{ categorySearch.sub2Category }}
              </a>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div
        class="category-panel__grid"
        ref="categoryGrid"
        @scroll="handleScroll"
    >
      <button
          class="category-panel__category category-panel__category--special"
          @click="fastLineOrBack"
      >
        <span class="category-panel__category-name">
          {{ category ? 'Back' : 'Fast Line' }}
        </span>
      </button>

      <button
          v-for="category in selectedCategories"
          :key="category.name"
          class="category-panel__category"
          @click="selectCategory(category.name)"
      >
        <span class="category-panel__category-name">
          {{ category.name }}
        </span>
      </button>
    </div>

    <div v-if="isScrollable" class="category-panel__scroll-controls">
      <button @click="scrollHorizontal(-1)" class="category-panel__scroll-btn category-panel__scroll-btn--left">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <button @click="scrollHorizontal(1)" class="category-panel__scroll-btn category-panel__scroll-btn--right">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCategories',
  props: {
    showMainCategories: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      category: undefined,
      subCategory: undefined,
      subSubCategory: undefined,
      isScrollable: false,
      scrollPosition: 0,
      maxScrollTop: 0
    };
  },
  computed: {
    categorySearch() {
      return this.$store.getters.getSearchCategories;
    },
    categories() {
      return this.$store.getters.getCategories;
    },
    selectedCategories() {
      if (this.category && this.subCategory) {
        let main = this.categories.find(
            (category) => category.name.localeCompare(this.category, undefined, { sensitivity: 'base' }) === 0
        );
        let sub = main.children.find(
            (category) => category.name.localeCompare(this.subCategory, undefined, { sensitivity: 'base' }) === 0
        );
        if (!sub || sub.length === 0) {
          return main.children;
        }
        return sub.children || [];
      } else if (this.category) {
        return this.categories
            .find((category) => category.name.localeCompare(this.category, undefined, { sensitivity: 'base' }) === 0)
            .children;
      } else {
        return this.categories;
      }
    }
  },
  mounted() {
    this.searchProducts();
  },
  methods: {
    clearCategory() {
      this.category = undefined;
      this.subCategory = undefined;
      this.subSubCategory = undefined;
      this.searchProducts();
    },
    selectMainCategory() {
      this.$store.commit('setLimit', 30);
      this.subSubCategory = undefined;
      this.subCategory = undefined;
      this.searchProducts();
    },
    selectSubCategory() {
      this.$store.commit('setLimit', 30);
      this.subCategory = undefined;
      this.searchProducts();
    },
    selectCategory(category) {
      this.$store.commit('setLimit', 30);
      if (this.category && this.subCategory) {
        this.subSubCategory = category;
      } else if (this.category) {
        this.subCategory = category;
      } else {
        this.category = category;
      }

      this.showCategories();
      this.searchProducts();
    },
    showCategories() {
      let show = this.showMainCategories;
      if (show) {
        show(false);
      }
    },
    searchProducts() {
      if (this.category) {
        let searchQuery = {
          category: this.category || '',
          subCategory: this.subCategory || '',
          sub2Category: this.subSubCategory || ''
        };
        this.$store.commit('setSearchCategories', searchQuery);
        this.$store.dispatch('searchStock', searchQuery);
      } else {
        this.$store.dispatch('getFastLine');
      }
    },
    fastLineOrBack() {
      if (this.category && this.subCategory && this.subSubCategory) {
        this.subSubCategory = undefined;
      } else if (this.category && this.subCategory) {
        this.subCategory = undefined;
      } else {
        this.category = undefined;
      }
      this.showCategories();
      this.searchProducts();
    },
    handleScroll() {
      const scroll = {
        scrollLeft: this.$refs.categoryGrid.scrollLeft,
        scrollWidth: this.$refs.categoryGrid.scrollWidth,
        clientWidth: this.$refs.categoryGrid.clientWidth
      };
      this.scrollPosition = scroll.scrollLeft;
      this.maxScrollTop = scroll.scrollWidth - scroll.clientWidth;
      this.isScrollable = scroll.scrollWidth > scroll.clientWidth;
    },
    scrollHorizontal(direction) {
      const scrollAmount = 250; // Adjust as needed
      const newScrollPosition = this.scrollPosition + (scrollAmount * direction);

      this.$refs.categoryGrid.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.category-panel {
  background-color: var(--card-bg);
  border-radius: var(--card-radius);
  box-shadow: var(--card-shadow);
  border: var(--card-border);
  padding: 0.2rem;
  position: relative;
  transition: var(--transition-default);

  &__header {
    margin-bottom: 0.75rem;
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;

    h4 {
      font-size: 1.1rem;
      color: var(--text-primary);
      margin: 0;
      font-weight: var(--font-weight-headings);
    }
  }

  &__reset-btn {
    background: transparent;
    border: none;
    color: var(--accent-electric-blue);
    cursor: pointer;
    transition: var(--transition-default);

    &:hover {
      transform: var(--hover-scale);
      color: var(--accent-electric-blue-dark);
    }

    svg {
      stroke: currentColor;
      width: 20px;
      height: 20px;
    }
  }

  &__breadcrumbs {
    nav ol {
      display: flex;
      list-style: none;
      padding: 0;
      margin: 0;
      gap: 0.5rem;
      font-size: 0.9rem;

      li {
        &:not(:last-child)::after {
          content: '>';
          margin-left: 0.5rem;
          color: var(--text-secondary);
        }

        a {
          color: var(--accent-electric-blue);
          text-decoration: none;
          transition: var(--transition-default);

          &:hover {
            color: var(--accent-electric-blue-dark);
          }
        }

        &.active a {
          color: var(--text-primary);
          cursor: default;
        }
      }
    }
  }

  &__grid {
    display: flex;
    gap: 0.5rem; /* Reduced gap */
    overflow-x: auto;
    scroll-behavior: smooth;

    // Hide scrollbar
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  &__category {
    flex-shrink: 0;
    min-width: 70px; /* Reduced width */
    height: 60px; /* Reduced height */
    border: var(--card-border);
    border-width: 1px;
    border-radius: var(--button-radius);
    background-color: var(--secondary-button-bg);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: var(--transition-default);
    padding: 0.3rem; /* Adjusted padding */
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.06),
      inset 0 0 0 1px rgba(255, 255, 255, 0.08);

    &--special {
      border-color: var(--accent-electric-blue);
      background-color: rgba(var(--accent-electric-blue-rgb), 0.15);
      box-shadow:
        0 0 0 1px rgba(var(--accent-electric-blue-rgb), 0.35),
        inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    }

    &:hover {
      transform: var(--hover-scale);
      box-shadow: 0 4px 10px rgba(var(--accent-electric-blue-rgb), 0.3);
      border-color: var(--accent-electric-blue);
      background-color: rgba(var(--accent-electric-blue-rgb), 0.15);
    }

    &-name {
      font-weight: var(--font-weight-buttons);
      font-size: 0.8rem; /* Reduced font size */
      color: var(--secondary-button-text);
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 90%;
      transition: var(--transition-default);
    }
  }

  &__scroll-controls {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 95%;
    margin-left: 1%;
    display: flex;
    justify-content: space-between;
    pointer-events: none;
  }

  &__scroll-btn {
    background-color: var(--secondary-button-bg);
    border: var(--card-border);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    pointer-events: auto;
    transition: var(--transition-default);
    box-shadow: var(--card-shadow);

    svg {
      stroke: var(--secondary-button-text);
      width: 18px;
      height: 18px;
    }

    &:hover {
      background-color: var(--secondary-button-bg-dark);
      transform: var(--hover-scale);
    }

    &--left {
      margin-left: -16px;
    }

    &--right {
      margin-right: -16px;
    }
  }

  @media (max-width: 768px) {
    &__category {
      min-width: 70px; /* Further reduced width */
      height: 55px; /* Further reduced height */
    }
  }

  @media (max-width: 480px) {
    &__category {
      min-width: 60px; /* Further reduced width */
      height: 50px; /* Further reduced height */
    }
  }
}

</style>
